/* eslint-disable sonarjs/no-duplicate-string */
import { Token } from '../../core/themeToken';

export const AIGCTokenLight: Token = {
  'font-weight-regular': 400,
  'font-weight-medium': 500,
  'font-weight-bold': 600,

  // 阴影大小
  'shadow-elevation-small': '',
  'shadow-elevation-medium': '',
  'shadow-elevation-large': '',

  // 字号
  'font-size-super-large': 24,
  'font-size-extra-large': 20,
  'font-size-large': 18,
  'font-size-base': 16,
  'font-size-medium': 14,
  'font-size-small': 13,
  'font-size-extra-small': 12,
  'font-size-super-small': 11,
  'font-size-xxs': 10,
  'font-size-xxxs': 9,

  // 行高
  'line-height-super-large': 30,
  'line-height-extra-large': 24,
  'line-height-large': 22,
  'line-height-base': 20,
  'line-height-medium': 18,
  'line-height-small': 16,
  'line-height-extra-small': 14,
  'line-height-super-small': 12,
  'line-height-xxs': 10,

  // 层级
  'z-index-axisLabel': 57,
  'z-index-series': 50,
  'z-index-splitLine': 0,
  'z-index-axisPointer': 25,
  'z-index-data-item': 50,
  'z-index-marker': 7,

  // 颜色 默认主色
  'color-visualization-primary': '#3366ff',
  'color-visualization-01': '#ff4019',
  'color-visualization-02': '#ff9500',
  'color-visualization-03': '#62b312',
  'color-visualization-04': '#14ccbd',
  'color-visualization-05': '#199fff',
  'color-visualization-06': '#4433ff',
  'color-visualization-07': '#ff33aa',
  'color-visualization-08': '#cc41d9',
  'color-visualization-09': '#858585',
  // 颜色 分割线颜色
  'color-visualization-divider': 'rgba(0, 0, 0, 0.06)',
  // 颜色 零轴颜色
  'color-visualization-divider-deep': '#858585',
  // 颜色 tooltip背景
  'color-visualization-tooltip': '#3b3b3b',
  // 颜色 axisPointer文本颜色和文本背景色和线的颜色
  'color-visualization-highlight-background-tick': '#3366ff',
  'color-visualization-highlight-line': 'rgba(0, 0, 0, 0.6)',
  'color-visualization-highlight-block': 'rgba(0, 0, 0, 0.1)',

  // 颜色 弱化背景色
  'color-background-weak': 'rgba(0, 0, 0, 0.04)',

  // 颜色 涨跌色
  'color-price-up': '#ff2436',
  'color-price-down': '#07abab',
  'color-price-even': 'rgba(0, 0, 0, 0.84)',

  // 交易业务-下跌
  'color-deal-price-down': '#4691ee',

  // 下跌-色弱模式
  'color-price-down-weakness': '#0ca3b0',

  // 文字/图标颜色
  'color-text-primary': 'rgba(0, 0, 0, 0.84)',
  'color-text-secondary': 'rgba(0, 0, 0, 0.6)',
  'color-text-tertiary': 'rgba(0, 0, 0, 0.4)',
  'color-text-quanternary': 'rgba(0, 0, 0, 0.24)',

  // 反色
  'color-text-inverse': '#ffffff',
  'color-text-inverse-primary': 'rgba(255, 255, 255, 0.84)',
  'color-text-inverse-secondary': 'rgba(255, 255, 255, 0.6)',
  'color-text-inverse-tertiary': 'rgba(255, 255, 255, 0.4)',
  'color-text-inverse-quanternary': 'rgba(255, 255, 255, 0.24)',

  // 文字链接色
  'color-text-link': '#4167d9'
};

export const AIGCTokenDark: Token = {
  'font-weight-regular': 400,
  'font-weight-medium': 500,
  'font-weight-bold': 600,

  // 阴影大小
  'shadow-elevation-small': '',
  'shadow-elevation-medium': '',
  'shadow-elevation-large': '',

  // 字号
  'font-size-super-large': 24,
  'font-size-extra-large': 20,
  'font-size-large': 18,
  'font-size-base': 16,
  'font-size-medium': 14,
  'font-size-small': 13,
  'font-size-extra-small': 12,
  'font-size-super-small': 11,
  'font-size-xxs': 10,
  'font-size-xxxs': 9,

  // 行高
  'line-height-super-large': 30,
  'line-height-extra-large': 24,
  'line-height-large': 22,
  'line-height-base': 20,
  'line-height-medium': 18,
  'line-height-small': 16,
  'line-height-extra-small': 14,
  'line-height-super-small': 12,
  'line-height-xxs': 10,

  // 层级
  'z-index-axisLabel': 57,
  'z-index-series': 50,
  'z-index-splitLine': 0,
  'z-index-axisPointer': 25,
  'z-index-data-item': 50,
  'z-index-marker': 7,

  // 颜色 默认主色
  'color-visualization-primary': '#3366ff',
  'color-visualization-01': '#ff4019',
  'color-visualization-02': '#ff9500',
  'color-visualization-03': '#62b312',
  'color-visualization-04': '#14ccbd',
  'color-visualization-05': '#199fff',
  'color-visualization-06': '#4433ff',
  'color-visualization-07': '#ff33aa',
  'color-visualization-08': '#cc41d9',
  'color-visualization-09': '#858585',
  // 颜色 分割线颜色
  'color-visualization-divider': 'rgba(255, 255, 255, 0.06)',
  // 颜色 零轴颜色
  'color-visualization-divider-deep': '#858585',
  // 颜色 tooltip背景
  'color-visualization-tooltip': '#3b3b3b',
  // 颜色 axisPointer文本颜色和文本背景色和线的颜色
  'color-visualization-highlight-background-tick': '#3366ff',
  'color-visualization-highlight-line': 'rgba(255, 255, 255, 0.6)',
  'color-visualization-highlight-block': 'rgba(255, 255, 255, 0.1)',

  // 颜色 弱化背景色
  'color-background-weak': 'rgba(255, 255, 255, 0.04)',

  // 颜色 涨跌色
  'color-price-up': '#ff2436',
  'color-price-down': '#07abab',
  'color-price-even': 'rgba(0, 0, 0, 0.84)',

  // 交易业务-下跌
  'color-deal-price-down': '#4691ee',

  // 下跌-色弱模式
  'color-price-down-weakness': '#0ca3b0',

  // 文字/图标颜色
  // 白版
  'color-text-primary': 'rgba(255, 255, 255, 0.84)',
  'color-text-secondary': 'rgba(255, 255, 255, 0.6)',
  'color-text-tertiary': 'rgba(255, 255, 255, 0.4)',
  'color-text-quanternary': 'rgba(255, 255, 255, 0.24)',

  // 颜色 反色
  'color-text-inverse': '#ffffff',
  'color-text-inverse-primary': 'rgba(255, 255, 255, 0.84)',
  'color-text-inverse-secondary': 'rgba(255, 255, 255, 0.6)',
  'color-text-inverse-tertiary': 'rgba(255, 255, 255, 0.4)',
  'color-text-inverse-quanternary': 'rgba(255, 255, 255, 0.24)',

  // 文字链接色
  'color-text-link': '#4167d9'
};
